import React from 'react';
import classNames from 'classnames';
import loginStyles from '../../../Login/index.module.scss';
import formStyles from '../../../Login/LoginContent/index.module.scss';
import { observer } from 'mobx-react-lite';
import { useLoginService } from '../../../../services/loginService';
import { useSignUpService } from '../../../../services/signUpService/index';
import { PatientDataContent } from './PatientDataContent';
import { DownloadAppContent } from './DownloadAppContent';
import styles from './index.module.scss';

function MobileWelcomeScreen({ url }: { url?: string }) {
  const { state } = useLoginService();
  const {
    state: { errorMessage, isWelcomeState },
  } = useSignUpService();

  return (
    <div
      className={classNames(
        formStyles.root,
        loginStyles.boxContainer,
        loginStyles.customGap,
        styles.root,
        'text-base font-normal text-neutrals-n-400  text-center text-neutrals-n-400 w-full',
        {
          [loginStyles.hide]: !(isWelcomeState || state.isWelcome),
        },
      )}
    >
      <div className="flex flex-col items-center">
        <span className={loginStyles.title}>Your account was created successfully.</span>
      </div>
      <div className="flex flex-col gap-4">
        <PatientDataContent />
        <DownloadAppContent url={url} />
      </div>
      {errorMessage || state.errorMessage ? (
        <div className={formStyles.error}>{errorMessage || state.errorMessage}</div>
      ) : null}
    </div>
  );
}
export default observer(MobileWelcomeScreen);
